<script setup lang="ts">
import { useRouter } from 'vue-router'
import SlideWithProgress from '../common/SlideWithProgress.vue'
import SlideLayout from '../common/SlideLayout.vue'

interface Props {
  next?: string
  progress?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  next: '',
})

const router = useRouter()

function handleViewportClick() {
  console.log(props)
  if (props.next) {
    router.push({ path: props.next })
  }
}
</script>

<template>
  <SlideWithProgress :class="{ 'cursor-pointer': next }" @click-viewport="handleViewportClick" :progress>
    <SlideLayout class="grid grid-rows-[1fr_15%] sm:grid-rows-[1fr_22%]">
      <div class="p-2 place-content-center">
        <slot></slot>
      </div>
      <div class="p-2">
        <div class="text-secondary text-center">
          <p v-if="$lang.th" class="text-th-slide-body">แตะที่หน้าจอเพื่อไปต่อ</p>
          <p v-if="$lang.en" class="text-en-slide-body">Tap to continue</p>
        </div>
      </div>
    </SlideLayout>
  </SlideWithProgress>
</template>
